import { render, staticRenderFns } from "./nav-top-workbench.vue?vue&type=template&id=8dde31dc&scoped=true"
import script from "./nav-top-workbench.vue?vue&type=script&lang=js"
export * from "./nav-top-workbench.vue?vue&type=script&lang=js"
import style0 from "./nav-top-workbench.vue?vue&type=style&index=0&id=8dde31dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dde31dc",
  null
  
)

export default component.exports